module.exports = __webpack_public_path__ + "static/media/music-screenshot-beyonce.7e6b8fc4.png";